<template>
  <div class="order-info">
    <div class="order-container">
      <div class="order-detail">
        <div class="order-detail-item flex-between">
          <span>{{ letter.v3ItemPrice }}</span>
          <span class="price" v-if="openShoppingCart && this.isCart"
            >{{ cartTotalPrice }} {{ currency }}</span
          >
          <span class="price" v-else>{{ transMount }} {{ currency }}</span>
        </div>
        <div
          class="order-detail-item flex-between"
          :class="{ disable: !curPayType.coupon }"
          @click="toggleCouponPopup"
        >
          <div class="coupon-box">
            <span class="">{{ letter.v3SelectCoupon }}</span>
            <div class="coupon-tag">{{ couponTagTex }}</div>
          </div>
          <span
            class="price coupon flex-center"
            :class="{ active: paytypeActiveCouponId }"
          >
            - {{ activePaytypeCouponReductPrice }} {{ currency }}
            <Icon class="price-icon" name="right" />
          </span>
        </div>
        <div class="order-detail-item flex-between" v-if="isShowTax">
          <span>{{ letter.v3Tax }}</span>
          <span class="price">{{ curTax }} {{ currency }} </span>
        </div>
        <div class="order-detail-item flex-between">
          <span>{{ letter.v3Total }}</span>
          <span class="total" v-if="openShoppingCart && this.isCart"
            >{{ realCartTotalPrice }} {{ currency }}
          </span>
          <span v-else class="total">{{ realTotalPrice }} {{ currency }} </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import coupon from '@mixins/officialTopupNew/coupon';
import product from '@mixins/officialTopupNew/product';
import zipcode from '@mixins/officialTopupNew/zipcode';
import cartAddAndDetail from '@mixins/officialTopupNew/cartAddAndDetail';
import { mapGetters, mapState } from 'vuex';
import { popupType, clickButton } from '@plugins/biPoint/_configWebstoreV35';
import { MODIFY_TAX } from '@store/officialTopupNew';
export default {
  name: 'OrderInfo',
  mixins: [coupon, product, zipcode, cartAddAndDetail],
  props: {
    curProduct: {
      type: Object,
      default: () => {}
    },
    curPayType: {
      type: Object,
      default: () => {}
    },
    realTotalPrice: {
      type: String | Number,
      default: 0
    },
    realCartTotalPrice: {
      type: String | Number,
      default: 0
    },
    transMount: {
      type: String | Number,
      default: 0
    },
    discountTransMount: {
      type: String | Number,
      default: 0
    }
  },
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      letter: state => state.letter,
      isUidLogin: state => state.login.isUidLogin,
      lang: state => state.lang,
      curLocation: state => state.curLocation,
      zipCode: state => state.zipCode,
      curTax: state => state.curTax,
      paytype: state => state.paytype,
      openShoppingCart: state => state.page.openShoppingCart
    }),
    ...mapGetters(['isCart']),
    couponTagTex() {
      //已推荐使用优惠券
      if (+this.curPayType.coupon === 1) {
        return this.paytypeActiveCouponId
          ? this.letter.v3CouponsSelected
          : this.letter.v3ClickSelectCoupon;
      } else {
        return this.letter.v3NoCouponsAvaliable;
      }
    },
    getRefreshTax() {
      const {
        cartTotalPrice,
        cartDiscountTransMount,
        discountTransMount,
        zipCode
      } = this;
      return {
        cartTotalPrice,
        cartDiscountTransMount,
        discountTransMount,
        zipCode
      };
    },
    currency() {
      return this.curPayType ? this.curPayType.show_currency : '';
    }
  },
  watch: {
    getRefreshTax: {
      immediate: true,
      deep: true,
      handler(newVal) {
        const totalPrice =
          this.openShoppingCart && this.isCart
            ? this.cartTotalPrice
            : this.discountTransMount;

        const discountPrice =
          this.openShoppingCart && this.isCart
            ? this.cartDiscountTransMount
            : this.discountTransMount;

        if (this.curLocation === 'US' && newVal.zipCode && totalPrice) {
          this.getCurrentTax({
            zipCode: newVal.zipCode,
            amount: this.paytype.coupon ? totalPrice : discountPrice,
            currency: this.currency
          });
        } else if (totalPrice === 0) {
          this.$store.commit(MODIFY_TAX, 0);
        }
      }
    }
  },
  methods: {
    toggleCouponPopup() {
      // 之前很坑的逻辑，如果不支持优惠券的渠道，不是清空列表，而是不显示入口，v3设置点击无效
      if (!this.curPayType.coupon) return;
      this.togglePaytypeCouponPopup();
    },
    postOrder() {
      this.$emit('postOrder');
    },
    cancelChooseCoupon() {
      clickButton({
        btnName: 'cancel_choose_coupon',
        locationKey: popupType.paytypeCouponPopup
      });
      this.hidePaytypeCouponPopup();
      this.updatePaytypeActiveCouponId('');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
.order-info {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  background: $moduleBackgroundColor;
  font-size: 0;
}

.order-container {
  display: flex;
  justify-content: space-between;
  position: relative;
  box-sizing: border-box;
  padding: 30px 20px;
  width: 100%;
}

.order-detail {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-right: 10px;
  line-height: 1.5;
  .order-detail-item {
    position: relative;
    font-size: 26px;
    font-weight: bold;
    cursor: pointer;

    .coupon-box {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      max-width: 70%;
      .coupon-tag {
        flex: 1;
        padding: 0 10px;
        border: 1px solid $themeColor;
        border-radius: 10px;
        font-size: 22px;
        font-weight: normal;
        color: $themeColor;
      }
    }
    .cancel-icon {
      width: 30px;
      height: 30px;
      cursor: pointer;
      margin-right: 10px;
    }
    .price {
      color: #333;
      &-icon {
        color: #333333;
        position: absolute;
        right: -30px;
        width: 30px;
        height: 30px;
      }

      &.active {
        color: $themeColor;
      }
    }
    .total {
      font-size: 30px;
      color: $themeColor;
      font-weight: bold;
    }

    &.disable {
      cursor: not-allowed;
    }
  }
  .order-detail-item + .order-detail-item {
    margin-top: 30px;
  }
}

#ssr-page.landscape {
  .order-container {
    padding: 20px;
  }
  .order-detail {
    .order-detail-item {
      font-size: 18px;

      .coupon-box {
        .coupon-tag {
          font-size: 16px;
        }
      }

      .total {
        font-size: 22px;
      }
    }
    .order-detail-item + .order-detail-item {
      margin-top: 14px;
    }
  }
}

@media only screen and (min-height: 640px) and (orientation: landscape) {
}
</style>
